import { useTheme } from 'styled-components';
import Icon, { IconType } from 'components/Icon';
import * as S from './styles';
import { useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { selectIsMobile } from 'redux/mode/reducers';
import { shallowEqual } from 'react-redux';

export enum SmallIconButtonState {
	REGULAR,
	DISABLED,
}

interface SmallIconButton {
	// if state is not provided, defaults to SmallIconButtonState.REGULAR
	state?: SmallIconButtonState;
	iconType: IconType;

	// this will be called when the button is clicked, if the state is not disabled
	onClick?: () => void;
}

const SmallIconButton = ({ state, iconType, onClick }: SmallIconButton) => {
	const theme = useTheme();

	const { isMobile } = useSelector(
		(r: RootReducer) => ({
			// make sure this includes deleted frames because the chat can show thumbnails of frames that have been deleted from the canvas
			isMobile: selectIsMobile(r.mode),
		}),
		shallowEqual
	);

	const iconColor =
		state === SmallIconButtonState.DISABLED ? theme.gray['400'] : theme.gray['1000'];

	//------------------------------------------------------------------------------------------------
	// HANDLERS
	//------------------------------------------------------------------------------------------------
	const onButtonPress = (event: any) => {
		// make sure we're clicking the button! (and not the tooltips, which also trigger this event)
		if (onClick && state !== SmallIconButtonState.DISABLED) {
			// If we have an onClick handler, don't let the event propagate
			event?.stopPropagation();
			event?.preventDefault();
			onClick();
		}
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<S.Base
			state={state || SmallIconButtonState.REGULAR}
			isMobile={isMobile}
			onClick={onButtonPress}
		>
			<S.Icon>
				<Icon
					type={iconType}
					width={isMobile ? 28 : 20}
					height={isMobile ? 28 : 20}
					color={iconColor}
				/>
			</S.Icon>
		</S.Base>
	);
};

export default SmallIconButton;
